import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'drfeel-zegna';

  constructor(private analytics: Analytics) {
    logEvent(this.analytics, 'zegna_page_view', { page_title: 'Home' });
  }
}
